// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__1CPfj","row":"Node_row__36nDJ","label":"Node_label__1f0bQ","footer":"Node_footer__3wL_v"};